import {
  aboutUs,
  allCustomerReviews,
  backmarketWarranty,
  blackFriday,
  boMerchant,
  buyBack,
  buyingGuides,
  cookiePolicy,
  dataProtection,
  giftCards,
  giftFinder,
  help,
  hireExternal,
  infosConsumer,
  insurancesWithRepair,
  legal,
  modelsComparison,
  referFriend,
  studentGoodDeals,
  termsBuyback,
  termsSale,
  termsUse,
} from './shared-links'
import type { FooterConfig } from './types'

export const deConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [
        aboutUs,
        {
          translationKey: 'press',
          href: '/de-de/about-us#scroll=false&target=heading-2-pressematerial',
        },
        hireExternal,
        {
          translationKey: 'trustpilot',
          href: 'https://de.trustpilot.com/review/www.backmarket.de',
        },
      ],
      socials: [
        {
          name: 'instagram',
          href: 'https://www.instagram.com/backmarket_de',
        },
        {
          name: 'youtube',
          href: 'https://www.youtube.com/@backmarketdeutschland',
        },
        { name: 'facebook', href: 'https://www.facebook.com/backmarket' },
        { name: 'x', href: 'https://x.com/back_market_de' },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        {
          translationKey: 'contactUs',
          href: 'https://help.backmarket.com/hc/de/articles/360026654654-Wie-kontaktiere-ich-den-Kundenservice-von-Back-Market',
        },
        help,
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/de/articles/360026646054-In-welches-Land-kann-ich-liefern-lassen-und-wie-viel-kostet-mich-das',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/de/categories/360002106194-R%C3%BCckgabe-R%C3%BCckerstattung-Returns-refunds',
        },
      ],
    },
    {
      titleKey: 'categoryServices',
      links: [
        referFriend,
        backmarketWarranty,
        insurancesWithRepair,
        buyBack,
        studentGoodDeals,
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.de/de-de/seller/home',
        },
        boMerchant,
        {
          translationKey: 'paymentMethods',
          href: 'https://help.backmarket.com/hc/de/articles/360026643854-Welche-Zahlungsarten-gibt-es-auf-Back-Market',
        },
      ],
    },
    {
      titleKey: 'categoryGuides',
      links: [
        giftCards,
        buyingGuides,
        modelsComparison,
        allCustomerReviews,
        giftFinder,
        blackFriday,
      ],
    },
    {
      titleKey: 'categoryLaw',
      links: [
        termsUse,
        termsSale,
        termsBuyback,
        cookiePolicy,
        dataProtection,
        infosConsumer,
        legal,
        {
          translationKey: 'illegalContent',
          href: 'https://help.backmarket.com/hc/de/requests/new?ticket_form_id=12226993197084',
        },
      ],
    },
    {
      logos: ['bcorp'],
    },
  ],
}
